import { render, staticRenderFns } from "./SocialLinks.vue?vue&type=template&id=7df0855e&"
import script from "./SocialLinks.vue?vue&type=script&lang=js&"
export * from "./SocialLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IFacebook: require('/opt/build/repo/components/svg/Facebook.vue').default,IInstagram: require('/opt/build/repo/components/svg/Instagram.vue').default,ILinkedIn: require('/opt/build/repo/components/svg/LinkedIn.vue').default,ITwitter: require('/opt/build/repo/components/svg/Twitter.vue').default})
